// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1f087e54","424":"40cff367","455":"935c77ce","546":"74faf12b","711":"2ee1600c","776":"0c0b4219","869":"fbd5bb3c","977":"bf899e87"}[chunkId] + ".chunk.js";
};